module.exports = __webpack_public_path__ + "static/media/1004995.43048d34.png";